import { render, staticRenderFns } from "./ChatMessageItem.vue?vue&type=template&id=50b0655e&scoped=true"
import script from "./ChatMessageItem.vue?vue&type=script&lang=js"
export * from "./ChatMessageItem.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageItem.vue?vue&type=style&index=0&id=50b0655e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b0655e",
  null
  
)

export default component.exports